import React, { useMemo } from "react";
import { SupervisorClinicOption } from "../api/contracts";

export function TeamClinicFilter({
  clinicOptions,
  value,
  onChange,
  compact = false,
}: {
  clinicOptions: readonly SupervisorClinicOption[];
  value: string;
  onChange: (clinicId: string) => void;
  compact?: boolean;
}) {
  const sortedOptions = useMemo(
    () =>
      [
        ...new Map(clinicOptions.map((clinic) => [clinic.id, clinic])).values(),
      ].sort((left, right) =>
        left.clinicName.localeCompare(right.clinicName, undefined, {
          sensitivity: "base",
        }),
      ),
    [clinicOptions],
  );

  return (
    <label className="cp-team-clinic-filter">
      <span className={compact ? "cp-visually-hidden" : undefined}>Clinic</span>
      <select
        className="cp-form-input"
        aria-label={compact ? "Clinic" : undefined}
        value={value}
        onChange={(event) => onChange(event.currentTarget.value)}
      >
        <option value="">All Clinics</option>
        {sortedOptions.map((clinic) => (
          <option key={clinic.id} value={clinic.id}>
            {clinic.clinicName}
          </option>
        ))}
      </select>
    </label>
  );
}

export function TeamClinicUnavailableState({
  onViewAllClinics,
}: {
  onViewAllClinics: () => void;
}) {
  return (
    <div className="cp-state" role="status">
      <h2>The selected clinic is no longer available.</h2>
      <button
        type="button"
        className="cp-button cp-button--secondary"
        onClick={onViewAllClinics}
      >
        View All Clinics
      </button>
    </div>
  );
}
